import { withAnalyticsTracking } from '../../../utils/withAnalyticsTracking'
import { StaticActionHandler } from '../actionHandlers'
import { TransactionsSalesTaxPaymentsActionType } from '../utils/getSalesTaxPaymentsActions'

export const salesTaxPaymentsActionHandlers: Record<TransactionsSalesTaxPaymentsActionType, StaticActionHandler> = {
  [TransactionsSalesTaxPaymentsActionType.VoidPayment]: withAnalyticsTracking(
    ({ openModal, voidVatDeclarationPaymentModalId }) => {
      openModal(voidVatDeclarationPaymentModalId)
    },
    'Sales Tax Payments',
    TransactionsSalesTaxPaymentsActionType.VoidPayment,
  ),
}
